import NewsletterForm from "@/components/feature/NewsletterForm";

export default function NewsletterSection() {
  return (
    <section id="newsletter" className="scroll-mt-24 bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-content px-4 md:px-6">
        <div className="grid grid-cols-1 overflow-hidden rounded-lg border border-background-200 lg:grid-cols-2">
          <div className="bg-primary-950 p-8 md:p-10">
            <p className="mb-3 inline-flex items-center gap-2 text-xs uppercase tracking-[0.28em] text-accent-400">
              <span className="inline-flex h-4 w-4 items-center justify-center">
                <i className="ri-mail-send-line" />
              </span>
              Newsletter
            </p>
            <h2 className="font-heading text-2xl font-bold text-background-50 md:text-3xl">
              订阅吃瓜情报
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-background-300">
              每个赛事周，我们会把新整理的现场片段、评测复盘和时间线更新一封邮件发给你。不发广告，不做推广，只发吃瓜。
            </p>
            <ul className="mt-6 space-y-2.5 text-sm text-background-200">
              <li className="flex items-center gap-2">
                <span className="inline-flex h-4 w-4 items-center justify-center text-accent-400">
                  <i className="ri-check-line" />
                </span>
                新内容上线提醒，不错过任何名场面
              </li>
              <li className="flex items-center gap-2">
                <span className="inline-flex h-4 w-4 items-center justify-center text-accent-400">
                  <i className="ri-check-line" />
                </span>
                完整的现场时间线，拒绝断章取义
              </li>
              <li className="flex items-center gap-2">
                <span className="inline-flex h-4 w-4 items-center justify-center text-accent-400">
                  <i className="ri-check-line" />
                </span>
                随时可以退订，一键完成
              </li>
            </ul>
          </div>

          <div className="flex flex-col justify-center bg-background-100 p-8 md:p-10">
            <h3 className="font-heading text-lg font-semibold text-foreground-950">
              留下邮箱，前排占座
            </h3>
            <p className="mt-2 text-sm text-foreground-600">
              我们只会用这个邮箱发送吃瓜情报，不会用于其他用途。
            </p>
            <div className="mt-6">
              <NewsletterForm />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}